import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "app/auth/auth.service";
import { DashboardService } from "app/dashboard/dashboard.service";

@Component({
  selector: "app-master-panel",
  templateUrl: "./master-panel.component.html",
  styleUrls: ["./master-panel.component.scss"],
})
export class MasterPanelComponent implements OnInit {
  filterTerm: string;
  subitemTrue: boolean = false;
  
  urlArray: any = [
  ];
  constructor(
    public dialogRef: MatDialogRef<MasterPanelComponent>,
    public dashboardService: DashboardService,private authservice:AuthService
  ) {
    debugger
     this.urlArray= [ 
  ]

  }

  ngOnInit(): void {}
  closePanel(event, item) {
    this.dashboardService.reportTitle = item.rname;
    this.dialogRef.close();
  }
  subclick() {
    this.subitemTrue = true;
  }
  seachroute(event) {}
}
